import { render, staticRenderFns } from "./residents.vue?vue&type=template&id=4358d858&scoped=true"
import script from "./residents.vue?vue&type=script&lang=js"
export * from "./residents.vue?vue&type=script&lang=js"
import style0 from "./residents.vue?vue&type=style&index=0&id=4358d858&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4358d858",
  null
  
)

export default component.exports